export enum VesselTypeEnum {
    Barge = 2,
    Bulker = 3,
    Container = 5,
    Passenger = 9,
    Cargo = 11,
    Tanker = 12,
    Tugboat = 13,
    Ferry = 30,
    SpecialCraft = 32,
    Fishing = 49,
    Unspecified = 94,
    PortPatrolSafety = 96,
    WingInGrnd = 100,
    SearchAndRescue = 101,
    PleasureCraft = 102,
    HighSpeedCraft = 103,
    SailingVessel = 104,
    Other = 105,
    PassengerCruiseShip = 1071,
}

export enum VesselEnginePowerUnitEnum {
    Kilowatt = 1,
    Horsepower = 2,
}
